export const SENTRY_ERROR_TYPES = {
	Component: 'Component',
	API: 'API',
	Unhandled: 'Unhandled',
	AutoLogout: 'AutoLogout',
	ChunkLoadFailed: 'ChunkLoadFailed',
};
